// LOAD ALL THE READ ONLY DATA

import { makeSetReducer } from "../utils";

export const comercialesFullfilledReducer = makeSetReducer(['comerciales/fullfilled']);
export const recambistasFullfilledReducer = makeSetReducer(['recambistas/fullfilled']);
export const atencionClienteFullfilledReducer = makeSetReducer(['atencion_cliente/fullfilled']);
export const administracionFullfilledReducer = makeSetReducer(['administracion/fullfilled']);